/**
 * Helper para leer/escribir en sessionStorage con error handling
 * Fallback silencioso si sessionStorage no está disponible (modo incógnito, storage lleno, etc)
 */
export const safeSessionStorage = {
    getItem: (key: string): string | null => {
        try {
            return sessionStorage.getItem(key)
        } catch (e) {
            if (process.env.NODE_ENV === 'development') {
                console.warn('[sessionStorage] Read failed (incognito mode?)', { key, error: e })
            }
            return null
        }
    },
    setItem: (key: string, value: string): boolean => {
        try {
            sessionStorage.setItem(key, value)
            return true
        } catch (e) {
            if (process.env.NODE_ENV === 'development') {
                console.warn('[sessionStorage] Write failed (quota exceeded or incognito mode?)', { key, error: e })
            }
            return false
        }
    },
}
